
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 26.457l5.813-.739M7.5 31.667l7.313-.949M6 36.667l8.5-1","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M55 43.833l-20 7.5V13l20 7.917v22.916z","fill":"#C7CCD1"}}),_c('path',{attrs:{"d":"M43.333 28.833V15.5l5 2.689v8.944l-5 1.7z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M55 43.833l-20 7.5V13l20 7.917v22.916z","stroke":"#000","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M43.333 16.333V28.86l5.834-1.597V18.86","stroke":"#000","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15 43.833l20 7.5V13l-20 7.917v22.916z","fill":"#fff","stroke":"#000","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    